var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 235,
    height: 321,
    viewBox: "0 0 235 321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19633",
    "data-name": "Rectangle 19633",
    width: 235,
    height: 321,
    transform: "translate(4.034 0.671)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fuel",
    transform: "translate(-4.034 -0.671)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    d: "M.06,357.335Q.06,180.062,0,2.777C0,.507.507,0,2.777,0q122.2.109,244.393,0c2.258,0,2.777.507,2.777,2.777q-.091,175.933,0,351.853c0,2.258-.507,2.777-2.777,2.777Q123.615,357.3.06,357.347Z",
    transform: "translate(-1.018 -0.02)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49823",
    "data-name": "Group 49823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    "data-name": "Path 3330",
    d: "M159.718,127.073v3.646q0,59.894-.06,119.776c0,2.644.507,3.586,3.381,3.5,6.7-.205,10,3.248,10.009,9.9,0,2.717.024,5.433,0,8.15-.048,5.566-3.441,9.056-9.007,9.08-13.173.048-26.346.012-39.519.012H46.39c-7.474,0-10.468-2.97-10.468-10.335,0-2.62-.024-5.228,0-7.848.06-5.361,3.489-8.875,8.814-9.044q4.5-.145,4.5-4.721V91.406c0-11.784,6.508-18.292,18.28-18.292h74.51c10.9,0,17.664,6.762,17.677,17.689.012,8.645.048,17.3-.036,25.947-.024,1.9.35,2.934,2.33,3.815,5.651,2.5,8.633,7.051,8.657,13.306.048,12.774,0,25.549.024,38.311a15.42,15.42,0,0,0,.278,3.586,6.25,6.25,0,0,0,12.328-.978,25.433,25.433,0,0,0,.06-2.717q0-47.361.048-94.734a6.237,6.237,0,0,0-2.041-5.011c-3.791-3.6-7.4-7.389-11.144-11.036a6.2,6.2,0,0,1-1.992-4.818c.048-7.039-.06-14.078,0-21.118a5.294,5.294,0,0,0-1.739-4.25c-2.91-2.777-5.663-5.711-8.536-8.536-1.654-1.63-2.33-3.441-.592-5.264,1.859-1.956,3.791-1.316,5.506.411q12.913,12.9,25.851,25.778a5.616,5.616,0,0,1,1.57,4.371q-.036,63.208-.036,126.4a13.2,13.2,0,1,1-26.394.036c-.1-13.173-.048-26.346-.012-39.519a8.359,8.359,0,0,0-4.154-7.715Z",
    transform: "translate(6.43 3.32)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3331",
    "data-name": "Path 3331",
    d: "M151.513,162.109v81.754c0,5.2.785,6.013,5.844,6.025s7.607,2.6,7.607,7.74q0,5.7-5.723,5.7H45.828q-4.238,0-4.238-4.141c0-2.016.121-4.033-.036-6.025-.193-2.536.869-3.32,3.332-3.308,11.06.1,22.12.036,33.18.036,4.347,0,5.832-.881,5.868-3.429.036-2.608-1.461-3.514-5.747-3.526-6.834,0-13.68-.109-20.514.06-2.342.06-2.8-.712-2.8-2.9q.091-80.233.048-160.478c0-6.749,3.876-10.613,10.71-10.625q37.545-.036,75.1,0c7.16,0,10.758,3.646,10.758,10.77v82.358Z",
    transform: "translate(7.596 14.287)",
    fill: "#f1f8ea",
    stroke: "#1d1d1b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3332",
    "data-name": "Path 3332",
    d: "M159.413,60.569c-2.9-2.97-5.18-5.3-7.462-7.631a2.2,2.2,0,0,1-.592-1.642,123.165,123.165,0,0,1,.652-15.226c2.294,2.427,4.6,4.842,6.858,7.293a2.287,2.287,0,0,1,.519,1.352C159.426,49.678,159.413,54.652,159.413,60.569Z",
    transform: "translate(30.376 7.462)",
    fill: "#fdfdfd",
    stroke: "#1d1d1b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3333",
    "data-name": "Path 3333",
    d: "M98.869,134.775q-12.8,0-25.621,0c-7.8-.012-11.507-3.707-11.507-11.4q0-17.477,0-34.967c0-6.774,3.888-10.77,10.6-10.794q26.823-.072,53.658,0c6.423.012,10.36,3.96,10.384,10.335q.072,18.238,0,36.476c-.024,6.4-3.9,10.275-10.384,10.336-9.044.085-18.087.024-27.131.024Z",
    transform: "translate(11.787 16.072)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3334",
    "data-name": "Path 3334",
    d: "M96.042,213.052c2.608,0,5.216-.024,7.824,0,2.222.024,3.695,1.063,3.743,3.393.06,2.367-1.437,3.489-3.622,3.514q-8.114.109-16.252,0c-2.21-.036-3.707-1.232-3.634-3.538.072-2.282,1.582-3.357,3.8-3.369,2.7-.024,5.421,0,8.126,0Z",
    transform: "translate(16.425 44.168)",
    fill: "#20201f",
    stroke: "#1d1d1b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3335",
    "data-name": "Path 3335",
    d: "M98.31,83.362h25.609c3.731,0,4.407.676,4.419,4.383q.018,17.332,0,34.653c0,3.489-.724,4.19-4.286,4.2q-26.062.018-52.124,0c-3.767,0-4.407-.64-4.407-4.371q0-17.332,0-34.653c0-3.5.712-4.2,4.274-4.214C80.634,83.338,89.472,83.362,98.31,83.362Z",
    transform: "translate(12.986 17.269)",
    fill: "#f1f8ea",
    stroke: "#1d1d1b",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/Fuel.4f3d359aee01797829f6480e19201c0f.svg";
export { ForwardRef as ReactComponent };